// eslint-disable-next-line
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
// eslint-disable-next-line
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = (props) => {
  // eslint-disable-next-line 
  const [username, setusername] = useState("");
  // eslint-disable-next-line 
  const [password, setpassword] = useState("");
  const [loading, setloading] = useState(false);

  const handleusername = (e) => {
    setusername(e.target.value);
  };

  const handlepassword = (e) => {
    setpassword(e.target.value);
  };

  const { enqueueSnackbar } = useSnackbar();

  const formData = {
    "username": username,
    "password": password
  }

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const login = async () => {
    const postdata = {
      username : formData.username,
      password : formData.password
    }
    
  try{
      setloading(true)
      const res = await axios
      .post(`${config.endpoint}/auth/login`,postdata)
      if(res.data.success)
      {
        enqueueSnackbar('logged in successfully', {variant : 'success'})
        setloading(false)
        persistLogin(res.data.token,res.data.username,res.data.balance)
        console.log(res);
      }
  }
    catch(error){
      if(localStorage.getItem('user'))
      {
        const loginDeets = JSON.parse(localStorage.getItem('user'))
        if(postdata.username === loginDeets.username && postdata.password !== loginDeets.password)
          enqueueSnackbar('Password is incorrect', {variant : 'error'})
          setloading(false)
      }
  
      else if(error.response.status === 400){
        enqueueSnackbar('Password is incorrect', {variant : "error"});
        console.log(error)
        setloading(false)
      }
      else{
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.", {variant : "error"})
        setloading(false)
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = () => {
    if (formData.username === "") {
      enqueueSnackbar("Username is a required field");
      return false;
    }
    else if (formData.password === "") {
      enqueueSnackbar("Password is a required field");
      return false;
    }
    else
    {
      login();
      return true;
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    window.localStorage.setItem('token',token)
    window.localStorage.setItem('username',username)
    window.localStorage.setItem('balance',balance)
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true}/>
      <Box className="content" style={{padding:30}}>
        <Stack spacing={2} style={{marginLeft:1000, marginRight:100, padding:30}}className="form">
        <h2 className="title">Login</h2>
        <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            onChange = {handleusername}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange = {handlepassword}
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          {loading ? <CircularProgress color="success" /> :<Link to='/'><Button className="button" variant="contained" onClick={validateInput} >LOGIN TO QKART</Button></Link>}
          <p className="secondary-action">Don’t have an account?<Link to='/register' className="link">Register Now</Link></p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
